var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEnvelope = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 15,
  height: 10,
  fill: "none",
  viewBox: "0 0 15 10"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M.988-.004h14v10h-14zm12.4 2.425-5.4 4.629-5.4-4.629v5.975h10.8zm-9.304-.825 3.904 3.346 3.904-3.346z"
})));
export default SvgEnvelope;